/**
 * Файл с основными константами приложения
 */

/** Стили для скелетона */
import { MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions } from '@angular/material/legacy-tooltip';

export const SKELETON_LOADER_CONFIG = {
    height: '32px',
    'background-color': 'var(--color-fui-surf-container-high)',
};

export enum SortOrder {
    ASK = 'ASC',
    DESC = 'DESC',
}

export enum EFactorDataLinks {
    row = 'factor/input/row/',
}

export const PASSWORD_VALIDATION_RULES_LATIN_CHAR =
    /^[0-9A-Za-z\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\;\'\:\"\|\,\.\<\>\/\?]+$/;
export const PASSWORD_VALIDATION_RULES_SPECIAL_CHAR = /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\;\'\:\"\|\,\.\<\>\/\?]/;
export const PASSWORD_VALIDATION_RULES_SMALL_CHAR = /[a-z]/;
export const PASSWORD_VALIDATION_RULES_CAPS_CHAR = /[A-Z]/;
export const PASSWORD_VALIDATION_RULES_NUMBER_CHAR = /\d/;

export const TOOLTIP_DEFAULT_OPTIONS: MatTooltipDefaultOptions = {
    showDelay: 500,
    hideDelay: 0,
    touchendHideDelay: 500,
    disableTooltipInteractivity: true,
};

/** Ссылка на путь до дефолтной картинки */
export const DEFAULT_REGISTRY_LOGO: string = '/assets/images/stubs/emptyPhoto.svg';
